import { Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { Link } from "react-router-dom";
import { generatePath } from "react-router";
import useMobileRoutes from "@/react/Webshop/Mobile/hooks/useMobileRoutes";
import { Trans } from "react-i18next";
import Box from "@mui/material/Box";
const SelectJobPoseDialog = ({ pictureSet, onClose, }) => {
    var _a, _b;
    const routes = useMobileRoutes();
    return (React.createElement(Dialog, { open: true, onClose: onClose },
        React.createElement(DialogTitle, null,
            React.createElement(Trans, null, "Choose yearbook pose")),
        React.createElement(DialogContent, null, ((_b = (_a = pictureSet.job.yearbookPoseSelection) === null || _a === void 0 ? void 0 : _a.poses) !== null && _b !== void 0 ? _b : []).map((jobPose) => {
            console.log("Generating path", routes["myaccount.picturesets.pictureset.yearbookpose.job-pose"]
                .path);
            return (React.createElement(Box, { key: jobPose.uuid, display: "flex", flexDirection: "column" },
                React.createElement(Button, { variant: "outlined", color: "primary", component: Link, to: generatePath(routes["myaccount.picturesets.pictureset.yearbookpose.job-pose"].path, { uuid: pictureSet.subject.uuid, jobPoseUuid: jobPose.uuid }), style: {
                        marginBottom: "16px",
                    } }, jobPose.name)));
        })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: onClose, color: "primary" },
                React.createElement(Trans, null, "Cancel")))));
};
export default SelectJobPoseDialog;
